<template>
  <div class="h-100">
    <h1>{{ title }}</h1>
    <b-container fluid class="px-0">
      <b-row>
        <b-col class="py-1">
          <!-- clster enrollment chart -->
          <ClusterEnrollment />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="py-1">
          <!-- positive infections chart -->
          <PositiveInfectionsBarChart />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="py-1">
          <!-- positive infections line chart -->
          <PositiveInfectionsLineChart />
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid>
      <b-row>
        <b-col lg="12" xl="4" class="py-1">
          <!-- subject retention donut -->
          <SubjectRetention />
        </b-col>
        <b-col lg="12" xl="4" class="py-1">
          <!-- subject infection donut -->
          <PositiveInfections />
        </b-col>
        <b-col lg="12" xl="4" class="py-1">
          <!-- Ento donut -->
          <EntoDonutChart />
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import { mapGetters } from 'vuex';
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import ClusterEnrollment from "@/components/metrics/eavetubes/ClusterEnrollment.vue";
import PositiveInfectionsBarChart from "@/components/metrics/eavetubes/PositiveInfectionsBarChart.vue";
import PositiveInfectionsLineChart from "@/components/metrics/eavetubes/PositiveInfectionsLineChart.vue";
import SubjectRetention from "@/components/metrics/eavetubes/SubjectRetention.vue";
import PositiveInfections from "@/components/metrics/eavetubes/PositiveInfections.vue";
import EntoDonutChart from "@/components/metrics/eavetubes/EntoDonutChart.vue";

export default {
  mixins: [DashboardBaseTemplate],
  components: {
    ClusterEnrollment,
    PositiveInfectionsBarChart,
    PositiveInfectionsLineChart,
    SubjectRetention,
    PositiveInfections,
    EntoDonutChart
  },
  data() {
    return {
      title: "Eave Tubes Data Portal Dashboard",
    }
  },
  created: function() {
    this.init();
  },
  computed: {
    ...mapGetters('user', ['inMyGroups'])
  },
  methods: {
    init: function() {
      // For here to check that token is still valid and launch login dialog if expired.
      HTTP.get("/users/api/me/")
      .then(() => {})
      .catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    },
  },
};
</script>

<style></style>
